module.exports = __webpack_public_path__ + "static/img/result_desktop.ea07a1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_desktop.jpg
// module id = 217F
// module chunks = 3